const resource = "/justificativas"
import api from "../axiosConfig"

export default {
  get() {
    return api.get(`${resource}`)
  },
  create(payload) {
    return api.post(`${resource}`, payload)
  },
  delete(id) {
    return api.delete(`${resource}/${id}`)
  },
}
